export default __webpack_public_path__ + "media/Ageing.443807e6.svg";